import { render, staticRenderFns } from "./ChartjsPieChart.vue?vue&type=template&id=3dd90637&"
import script from "./ChartjsPieChart.vue?vue&type=script&lang=js&"
export * from "./ChartjsPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports